import "./styles.css";
import { useEffect, useRef, useState } from "react";
import { Bell, Users, UserPlus, ShoppingCart, Award } from "lucide-react";
import Chart from "chart.js/auto";
import CoursesTable from "./Students";
import axios from "axios";
import { API_SRUDENT_URL, MAIN_URL } from "../../constants";
import { Card, PageHeader, StatCard } from "../../Components/ui";
import "./AdminDashboard.css";


// Faqat ko'rsatish uchun: 1250 → "1 250" (qiymatning o'zi o'zgarmaydi).
const formatStatValue = (value) => {
    if (typeof value !== "number" && !(typeof value === "string" && /^\d+$/.test(value))) return value;
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
};

// Ma'lumot hali kelmagan bo'lsa (undefined/null) karta skeleton holatida ko'rinadi.
const isMissing = (value) => value === undefined || value === null;

// Grafik ranglari va shrifti tokens.css dan o'qiladi.
const readToken = (name, fallback) => {
    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return value || fallback;
};

const withAlpha = (hex, alpha) => {
    const clean = hex.replace("#", "");
    const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
    const [r, g, b] = [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const CourseRow = ({ name, students, percent, color }) => (
    <tr className="row">
        <td>{name}</td>
        <td>{students}</td>
        <td>
            <div className="progress">
                <div
                    className={`progress-fill bg-${color}`}
                    style={{ width: percent }}
                />
            </div>
        </td>
    </tr>
);

const DashboardMain = () => {
    const lineChartRef = useRef(null);
    const donutChartRef = useRef(null);
    const [statistics, setStatistics] = useState(null)
    const TOKEN = localStorage.getItem('admin_token')
    const [studentDinamics, setStudentDinamics] = useState([])


    useEffect(() => {
        axios.get(`${MAIN_URL}/management/dashboard/statistics/head`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${TOKEN}`,
            },
        }).then((res) => {
            setStatistics(res.data)
        }).catch((err) => {

        })
    }, [])

    useEffect(() => {
        axios.get(`${MAIN_URL}/management/students-dinamics-weekly`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${TOKEN}`,
            },
        }).then((res) => {
            setStudentDinamics(res.data)
        }).catch((err) => {

        })
    }, [])

    // useEffect(() => {
    //     const lineChart = new Chart(lineChartRef.current, {
    //         type: "line",
    //         data: {
    //             labels: ["Du", "Se", "Chor", "Pay", "Ju", "Sha", "Yak"],
    //             datasets: [{ data: [40, 65, 52, 88, 70, 95, 110] }]
    //         },
    //         options: { plugins: { legend: { display: false } } }
    //     });

    //     const donutChart = new Chart(donutChartRef.current, {
    //         type: "doughnut",
    //         data: {
    //             labels: ["Tugatgan", "Jarayonda", "Boshlamagan"],
    //             datasets: [{ data: [30, 60, 10] }]
    //         }
    //     });

    //     return () => {
    //         lineChart.destroy();
    //         donutChart.destroy();
    //     };
    // }, []);

    const formatTrend = (value) => {
        if (value === null || value === undefined) return "+0%";
        return `${value > 0 ? "+" : ""}${value.toFixed(1)}%`;
    };

    const lineChartInstance = useRef(null);

    const chartLabels = studentDinamics.map(item => item.day_name);
    const chartData = studentDinamics.map(item => item.count);

//    const lineChartInstance = useRef(null);

useEffect(() => {
  if (!studentDinamics?.length) return;
  if (!lineChartRef.current) return;

  if (lineChartInstance.current) {
    lineChartInstance.current.destroy();
    lineChartInstance.current = null;
  }

  const lineColor = readToken("--chart-1", "#CD2525");
  const fontFamily = readToken("--font-sans", "Inter, system-ui, sans-serif");
  const gridColor = readToken("--gray-100", "#F1F5F9");
  const tickColor = readToken("--gray-500", "#64748B");
  const surfaceColor = readToken("--bg-surface", "#FFFFFF");
  const borderColor = readToken("--border", "#E2E8F0");
  const textPrimary = readToken("--text-primary", "#0F172A");
  const textSecondary = readToken("--text-secondary", "#475569");

  lineChartInstance.current = new Chart(lineChartRef.current, {
    type: "line",
    data: {
      labels: studentDinamics.map(i => i.day_name),
      datasets: [
        {
          data: studentDinamics.map(i => i.count),
          tension: 0.4,
          fill: true,
          cubicInterpolationMode: "monotone",
          borderColor: lineColor,
          borderWidth: 2,
          backgroundColor: (context) => {
            const { ctx, chartArea } = context.chart;
            if (!chartArea) return withAlpha(lineColor, 0.12);
            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, withAlpha(lineColor, 0.24));
            gradient.addColorStop(1, withAlpha(lineColor, 0));
            return gradient;
          },
          pointRadius: 3,
          pointHoverRadius: 6,
          pointBorderWidth: 2,
          pointHoverBorderWidth: 2,
          pointBackgroundColor: surfaceColor,
          pointBorderColor: lineColor,
          pointHoverBackgroundColor: lineColor,
          pointHoverBorderColor: surfaceColor,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: "index", intersect: false },
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: surfaceColor,
          borderColor: borderColor,
          borderWidth: 1,
          titleColor: textPrimary,
          bodyColor: textSecondary,
          titleFont: { family: fontFamily, size: 12, weight: "600" },
          bodyFont: { family: fontFamily, size: 12 },
          padding: 10,
          cornerRadius: 8,
          displayColors: false,
          caretSize: 6,
        },
      },
      scales: {
        x: {
          grid: { display: false },
          border: { display: false },
          ticks: { color: tickColor, font: { family: fontFamily, size: 12 } },
        },
        y: {
          beginAtZero: true,
          ticks: { precision: 0, color: tickColor, font: { family: fontFamily, size: 12 } },
          grid: { color: gridColor },
          border: { display: false },
        },
      },
    },
  });

  return () => {
    lineChartInstance.current?.destroy();
    lineChartInstance.current = null;
  };
}, [studentDinamics]);





    return (
        <div className="ui-dashboard">
            <PageHeader title="Dashboard" subtitle="Platformaning umumiy ko'rsatkichlari" />

            <div className="ui-dashboard__stats">
                <StatCard
                    icon={<Users />}
                    label="Jami studentlar"
                    value={formatStatValue(statistics?.total_students)}
                    trend={statistics ? formatTrend(statistics.month_growth_percentage) : "+0%"}
                    tone="info"
                    loading={isMissing(statistics?.total_students)}
                />

                <StatCard
                    icon={<UserPlus />}
                    label="Oxirgi 7 kun studentlar"
                    value={formatStatValue(statistics?.last_7_days_students)}
                    trend={statistics ? formatTrend(statistics.week_growth_percentage) : "+0%"}
                    tone="success"
                    loading={isMissing(statistics?.last_7_days_students)}
                />

                <StatCard
                    icon={<ShoppingCart />}
                    label="Sotilgan kurslar"
                    value={formatStatValue(statistics?.total_orders)}
                    trend={statistics ? formatTrend(statistics.monthly_sales_growth_percentage) : "+0%"}
                    tone="warning"
                    loading={isMissing(statistics?.total_orders)}
                />

                <StatCard
                    icon={<Award />}
                    label="Berilgan sertifikatlar"
                    value={formatStatValue(statistics?.total_certificates)}
                    tone="brand"
                    loading={isMissing(statistics?.total_certificates)}
                />
            </div>

            <Card title="Studentlar dinamikasi" subtitle="Oxirgi 7 kun">
                <div className="ui-dashboard__chart">
                    <canvas ref={lineChartRef} />
                </div>
                {/* <div className="card">
          <h3>Kurslar holati</h3>
          <canvas ref={donutChartRef} />
        </div> */}
            </Card>

            {/* <CoursesTable /> */}
        </div>
    );
};

export default DashboardMain;
